/* WhatsApp templates of the reminder settings: status labels, preview and error texts. */

export const MAX_CUERPO = 1024;
export const MAX_PIE = 60;
export const NOMBRE_VALIDO = /^[a-z0-9_]+$/;

export const ESTADO_PLANTILLA = {
  APPROVED: { label: "Aprobada", badge: "" },
  PENDING: { label: "Pendiente de aprobación", badge: "zr-badge--pending" },
  REJECTED: { label: "Rechazada", badge: "zr-badge--cancel" },
};

export const estadoDePlantilla = (status) => ESTADO_PLANTILLA[String(status || "").toUpperCase()] || { label: status || "", badge: "" };

/** Sample values for the preview; `local` is the venue's name from the form. */
export const ejemploDe = (local) => ({
  clientName: "Sofía Herrera",
  venueName: local || "Tu local",
  dateLabel: "viernes 30 de octubre",
  timeLabel: "10:30",
  details: "Corte mujer",
  address: "Av. Sarmiento 450",
  manageUrl: "zocotickets.com/g/4821",
  reviewUrl: "https://www.zocotickets.com/reservas/resenar/…",
  claimUrl: "https://www.zocotickets.com/lista-de-espera/…",
});

/** Template text with each `{{n}}` replaced by the sample of the field mapped to it (a "…" when unmapped). */
export const textoDeVistaPrevia = (texto, parametros = [], local = "") => {
  const ejemplo = ejemploDe(local);
  return String(texto || "").replace(/\{\{\s*(\d+)\s*\}\}/g, (_, n) => ejemplo[parametros[Number(n) - 1]] || "…");
};

/** How many positional variables a body uses: the highest `{{n}}`. */
export const cantidadDeVariables = (cuerpo) => {
  let max = 0;
  String(cuerpo || "").replace(/\{\{\s*(\d+)\s*\}\}/g, (_, n) => {
    max = Math.max(max, Number(n));
    return "";
  });
  return max;
};

export const iniciales = (nombre) =>
  String(nombre || "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join("") || "Z";

// Back `codigo` -> Spanish text. Meta's own `template_*` codes fall back to the generic one on purpose.
const MENSAJES = {
  template_name_invalid: "El nombre solo puede tener minúsculas, números y guion bajo.",
  template_body_required: "Escribí el mensaje de la plantilla.",
  template_body_too_long: `El mensaje no puede pasar de ${MAX_CUERPO} caracteres.`,
  template_footer_too_long: `El pie no puede pasar de ${MAX_PIE} caracteres.`,
  template_variables_invalid: "Los datos variables tienen que estar numerados en orden: {{1}}, {{2}}, {{3}}…",
  chat_sin_configurar: "La conexión con Zoco Chat no está configurada en el servidor. Avisá a soporte de Zoco.",
  chat_no_disponible: "Zoco Chat no responde en este momento. Probá de nuevo en unos minutos.",
  chat_credencial_invalida: "No pudimos autenticarnos con Zoco Chat. Avisale a soporte.",
};

/** Message for a failed Chat call, from the `codigo` the back sends. */
export const mensajeDeChat = (error, fallback) => {
  const codigo = error?.response?.data?.codigo;
  if (codigo && MENSAJES[codigo]) return MENSAJES[codigo];
  if (String(codigo || "").startsWith("template_")) return "WhatsApp no aceptó la plantilla. Revisá el nombre y el mensaje.";
  return fallback;
};

/** Whether trying again can help: not when the server itself lacks its Chat settings or credential. */
export const sePuedeReintentar = (error) => !["chat_sin_configurar", "chat_credencial_invalida"].includes(error?.response?.data?.codigo);

export const PLANTILLA_SIN_VERIFICAR = "No pudimos verificar el estado de la plantilla de WhatsApp. Volvé a verificar para poder guardar";

/** Why the chosen template can't be saved, or "" when it is APPROVED. `plantilla` is null when the list isn't loaded
 *  (`cargada` false) or the saved template no longer exists in it. Only an approved template may be saved. */
export const bloqueoDePlantilla = ({ templateName, plantilla, cargada }) => {
  if (!templateName) return "";
  if (!cargada) return PLANTILLA_SIN_VERIFICAR;
  if (!plantilla) return "La plantilla elegida ya no existe en Zoco Chat. Elegí otra para poder guardar";
  const estado = String(plantilla.status || "").toUpperCase();
  if (estado === "APPROVED") return "";
  if (estado === "PENDING") return "La plantilla todavía está en revisión de Meta. Vas a poder guardar cuando esté aprobada.";
  if (estado === "REJECTED") return `Meta rechazó la plantilla${plantilla.rejectionReason ? `: ${plantilla.rejectionReason}` : "."} Elegí otra para poder guardar`;
  return "La plantilla no está aprobada por Meta. Elegí otra para poder guardar";
};
